// extracted by mini-css-extract-plugin
export var disabled = "_1b-a";
export var hierarchyLinkGray = "_1b-4";
export var hierarchyLinkUnderline = "_1b-3";
export var hierarchyPrimary = "_1b-0";
export var hierarchySecondary = "_1b-1";
export var hierarchyTertiary = "_1b-2";
export var pressed = "_1b-6";
export var themeAction = "_1b-5";
export var themeDestructive = "_1b-8";
export var themeNormal = "_1b-7";
export var themeSuccess = "_1b-9";